import { put, getContext } from 'redux-saga/effects'
import importer from 'common/importer'
const { getCenters } = importer('GraphQL/Queries')
const PublicContentActions = importer('Stores/PublicContent/Actions')
export default function * main () {
  try {
    yield put(PublicContentActions.getCentersLoading())
    const apolloClient = yield getContext('client')
    const query = getCenters
    const {data, error} = yield apolloClient.query({query})
    if (error) {
      throw error
    }
    const centers = data.salesforce_donation_center__c
    const byState = yield mapByState(centers)
    yield put(PublicContentActions.getCentersSuccess(byState.sort(sortByState)))
  } catch (error) {
    yield put(PublicContentActions.getCentersFailure(error))
  }
}

const mapByState = list => {
  return new Promise((resolve, reject) => {
    try {
      const states = []
      if (list && list.length) {
        return list.forEach((item, index) => {
          const foundIndex = states.findIndex(i => i.state === item.state__c)
          if (foundIndex !== -1) { states[foundIndex].facilities.push(item) } else { states.push({ state: item.state__c, facilities: [item] }) }
          if (index === list.length - 1) { resolve(states) }
        })
      } else resolve(list)
    } catch (error) {
      reject(error)
    }
  })
}

const sortByState = (a, b) => {
  if (a.state < b.state) {
    return -1
  }
  if (a.state > b.state) {
    return 1
  }
  return 0
}
